import { CONFIRMED_GET_PATIENT_LIST } from "../actions/TokenSystemType";

const initialState = {
  patientList: [],
  // Add more state if needed
};

export default function TokenSystemReducer(state = initialState, action) {
  switch (action.type) {
    case CONFIRMED_GET_PATIENT_LIST:
      return {
        ...state,
        patientList: action.payload,
      };

    default:
      return state;
  }
}
